import * as api from "~/api";
import { FAQ } from "~/utils/urlApi";

// import axios from "axios";
// import * as types from "~/store/faq/faqType";
// export const getAllFAQ = async () => await axios.get(types.FAQ_URL);
// export const getFAQBySearch = async searchString => await axios.get(types.FAQ_URL + `?q=${searchString}`);

export const getAllFAQ = () => {
  return api.getHttpRequestAsync(`${FAQ.GET_ALL_FAQ}`);
};

export const getFAQBySearch = searchString => {
  return api.getHttpRequestAsync(FAQ.GET_ALL_FAQ + `?q=${searchString}`);
};
